import { API_CONFIG, apiService } from "../config/api";

interface GetStudyAlertsArgs {
  token?: string | null;
  studyId: string;
  startDate: string;
  endDate: string;
}

interface SummaryStats {
  lastModelRun: string | null;
  hoursAgo: number | null;
  nextModelRunAt: string;
  pendingAlerts: number;
  pendingParticipants: number;
  avgAdherence: number;
  maxAdherence: number;
  lowestAdherenceParticipants: Array<{
    participantId: string;
    adherence: number;
  }>;
  weeklyActions: {
    contacted: number;
    resolved: number;
    falsePositives: number;
  };
}

export const AlertsService = {
  async getStudyAlerts({
    token,
    studyId,
    startDate,
    endDate,
  }: GetStudyAlertsArgs) {
    const base = API_CONFIG.BASE_URL || process.env.REACT_APP_API_URL || "";
    const url = `${base}/api/anomaly-detection/alerts`;
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ studyId, startDate, endDate }),
    });

    if (!resp.ok) {
      let msg = `Failed to fetch alerts (${resp.status})`;
      try {
        const j = await resp.json();
        if (j?.error) msg = j.error;
      } catch {}
      throw new Error(msg);
    }
    return await resp.json();
  },

  async getSummaryStats(studyId: string): Promise<SummaryStats> {
    const endpoint = `/api/anomaly-detection/alerts/summary?studyId=${encodeURIComponent(
      studyId,
    )}`;
    const data = await apiService.get(endpoint);
    return data.summary as SummaryStats;
  },
};
